import { VBaseSelect } from '../VBaseSelect';
import VInnerLanguageSwitch from './VInnerLanguageSwitch';
import type { VLanguageSwitchProps } from './type';

const VLanguageSwitcher = ({
  languageList,
  placement = 'bottom',
  ref,
  selectedLanguage,
  onItemClick,
}: VLanguageSwitchProps & React.RefAttributes<HTMLDivElement>) => {
  const onChange = (e: any) => {
    const selectedValue = e?.target.value;
    const selectedItem = languageList.find(
      item => item.value === selectedValue,
    );
    if (selectedItem) {
      onItemClick?.(selectedItem);
    }
  };

  return (
    <VBaseSelect
      itemList={languageList}
      value={selectedLanguage}
      onChange={onChange}
      placement={placement}
    >
      <VInnerLanguageSwitch
        ref={ref}
        selectedLanguage={selectedLanguage}
        languageList={languageList}
      />
    </VBaseSelect>
  );
};

VLanguageSwitcher.displayName = 'VLanguageSwitcher';

export default VLanguageSwitcher;
